// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"b971bcc0","12830":"b971bcc0","29553":"b971bcc0","51934":"b971bcc0","84690":"b971bcc0"}[chunkId] + ".chunk.css";
};